module.exports = __webpack_public_path__ + "static/media/ratain.6cb9e499.png";